import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FilePathModel } from './file-path.model';

@Component({
    selector: 'pace-core-file-path',
    templateUrl: './file-path.component.html',
    styleUrls: ['./file-path.component.scss'],
    standalone: false,
})
export class FilePathComponent {
    @Input()
    public model: FilePathModel;

    @ViewChild('textAreaElement')
    private textAreaElement: ElementRef;
    public constructor(public readonly modalInstance: BsModalRef) {}

    public onCopyClicked(): void {
        (<HTMLInputElement>this.textAreaElement.nativeElement).select();
        document.execCommand('copy');
        this.modalInstance.hide();
    }

    public onCloseClicked(): void {
        this.modalInstance.hide();
    }
}
